import { BaseMessage, MessageType, ToolMessage } from '@langchain/core/messages'

export type LangGraphMessage = BaseMessage & {
  role: MessageType
  tool_calls: Array<ToolMessage & { args: Record<string, any> }>
}

export enum GraphName {
  supportAssistant = 'supportAssistant',
  solveIssue = 'solveIssue'
}
